import { DateTime } from 'luxon';

/** Full 24-hour chart window from midnight on `date` through midnight the next day. */
export const getForecastDayChartDomain = (
  date: string,
  timeZone: string,
): { start: Date; end: Date } => {
  const start = DateTime.fromISO(`${date}T00:00:00`, { zone: timeZone });
  const end = start.plus({ days: 1 });
  return {
    start: start.toJSDate(),
    end: end.toJSDate(),
  };
};

export const isTimeInForecastDayChartDomain = (
  time: Date,
  date: string,
  timeZone: string,
): boolean => {
  const { start, end } = getForecastDayChartDomain(date, timeZone);
  const timeMs = time.getTime();
  return timeMs >= start.getTime() && timeMs <= end.getTime();
};

export const isIsoTimeInForecastDayChartDomain = (
  isoTime: string,
  date: string,
  timeZone: string,
): boolean => {
  const pointDateTime = DateTime.fromISO(isoTime, { zone: timeZone });
  if (!pointDateTime.isValid) {
    return false;
  }

  return isTimeInForecastDayChartDomain(
    pointDateTime.toJSDate(),
    date,
    timeZone,
  );
};
